import React from 'react';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { useDispatch, useSelector } from 'react-redux';
import { setPickedDate } from 'redux/actions'
import { SubHeaderContainer } from '../styles';
import {
  DoubleLeftDateIcon,
  DoubleRightDateIcon,
} from 'assets/icons';
import StyledDatePicker from 'components/DatePicker';
import colors from 'constants/colors';

const SubHeader = ({ timelineState }) => {

  const pickedDate = useSelector(state => state.pickedDateReducer.pickedDate)
  const dispatch = useDispatch() 
  
  const { state, setState } = timelineState;

  const onPreWeekClick = () => {
    dispatch(setPickedDate(moment(pickedDate).tz(TIME_ZONE).subtract(7, 'day').valueOf()))
    setState({
      visibleTimeStart: moment(state.visibleTimeStart).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
      visibleTimeEnd: moment(state.visibleTimeEnd).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
      today: moment(state.today).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
      endToday: moment(state.endToday).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
    });
  };

  const onNextWeekClick = () => {
    dispatch(setPickedDate(moment(pickedDate).tz(TIME_ZONE).add(7, 'day').valueOf()))
    setState({
      visibleTimeStart: moment(state.visibleTimeStart).tz(TIME_ZONE).add(7, 'day').valueOf(),
      visibleTimeEnd: moment(state.visibleTimeEnd).tz(TIME_ZONE).add(7, 'day').valueOf(),
      today: moment(state.today).tz(TIME_ZONE).add(7, 'day').valueOf(),
      endToday: moment(state.endToday).tz(TIME_ZONE).add(7, 'day').valueOf(),
    });
  };

  return (
    <SubHeaderContainer>
      <div className="contentContainer">
        <DoubleLeftDateIcon
          onClick={onPreWeekClick}
          style={{ cursor: 'pointer' }}
        />
        <div className="dateSection">
          <StyledDatePicker
            dateValue={moment(pickedDate).tz(TIME_ZONE)}
            setDate={(date)=>{
              dispatch(setPickedDate(moment(date).tz(TIME_ZONE).valueOf()))
            }}
            timelineState={timelineState}
            variant="standard"
            additionalstyle={`
              width: 137px;
                
              input{
                font-weight: 400;
                padding-right: 26px;
                border-bottom: 2px solid ${colors.darkGrey};
              }

              .MuiInput-root {
                margin-top: 0;
              }
            `}
          />
        </div>
        <DoubleRightDateIcon
          onClick={onNextWeekClick}
          style={{ cursor: 'pointer ' }}
        />
      </div>
    </SubHeaderContainer>
  );
};

export default SubHeader;
